import { createContext } from "react";

const userLoginContext= createContext();

export default userLoginContext;